import DataTable from 'datatables.net-react';
import { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import Badge from 'react-bootstrap/Badge';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Form from 'react-bootstrap/Form';
import ReactDOMServer from 'react-dom/server';
import { UserEditLogServices } from '../../services/UserEditLogServices';
import * as BullCache from "../../util/BullCache";
import AdminDropdown from '../components/AdminDropdown';
import BrokerDropdown from '../components/BrokerDropdown';
import ClientDropdown from '../components/ClientDropdown';
import From from '../components/From';
import MasterDropdown from '../components/MasterDropdown';
import To from '../components/To';
import "../custom.css";



function Usereditlog() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [selectedAdmin, setSelectedAdmin] = useState(null);
  const [selectedMaster, setSelectedMaster] = useState(null);
  const [selectedBrokerId, setSelectedBrokerId] = useState(null);
  const [selectedSubBrokerId, setSelectedSubBrokerId] = useState(null);
  const [selectedClient, setSelectedClient] = useState('');
  const [selectedStatus, setSelectedStatus] = useState({ value: 'UPDATE', label: 'UPDATE' });
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [client, setClient] = useState([]);
  const [calledFirstTime, setCalledFirstTime] = useState(false);


  var user = BullCache.getFromCache("user");

  const handleStatusChange = (selectedOption) => {
    setSelectedStatus(selectedOption);
  };

  const handleSelectedClientChange = (selected) => {
    setSelectedClient(selected?.userId);
  };

  const clientOptions = client.map(c => ({
    value: c.userid,
    label: `${c.firstName} (${c.userName})`
  }));


  useEffect(() => {
    UserEditLogServices.getusers({ adminId: user.adminId }).then((res) => {
      if (res.code === 1) {
        if (res.data.userList.length > 0) {
          setClient(res.data.userList);
        }
      }
    });
  }, [user.adminId]);

  useEffect(() => {
    if (fromDate && toDate && !calledFirstTime) {
      const dataToSubmit = {
        adminId: user.adminId,
        date: fromDate,
        endDate: toDate,
      };

      fetchData(dataToSubmit);
      setCalledFirstTime(true);
    }
  }, [fromDate, toDate]);

  const fetchData = (dataToSubmit) => {
    setLoading(true);
    UserEditLogServices.getTableData(dataToSubmit)
      .then((resp) => {
      setLoading(false);
        if (resp.code === 1 && resp.data.logList.length > 0) {
          setData(resp.data.logList);
        } else {
          setData([]);
        }
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
      });
  };

  const columns = [
    { title: 'CLIENT', data: 'client' },
    {
      title: 'CHANGE LOGS', render: (data, type, full, meta) => {
        const badgeColors = ['primary', 'warning', 'success', 'danger', 'secondary', 'info', 'light', 'dark'];

        let badges = '';
        for (let i = 0; i < full.changeLogs.length; i++) {

          let text = full.changeLogs[i];
          const colorIndex = i % badgeColors.length;
          badges += ReactDOMServer.renderToString(<Badge bg={badgeColors[colorIndex]}>{text}</Badge>) + '';
        }

        return badges;
      }
    },
    { title: 'TIME', data: 'orderTime' },
    {
      title: 'IP',
      render: (data, type, full, meta) => {
        const ip = full.ip;
        if (!ip) return null; // If there's no IP, return null (nothing to display)

        // Create the anchor tag for the IP
        return `<a href="https://whatismyipaddress.com/ip/${ip}" target="_blank">${ip}</a>`;
      },
    },
  ];

  const handleSubmit = () => {
    setLoading(true);
    const dataToSubmit = {
      adminId: user.adminId,
      date: fromDate,
      endDate: toDate,
    };
    if (selectedClient) {
      dataToSubmit.userId = selectedClient;
      dataToSubmit.adminId = user.adminId;
    } else if (selectedSubBrokerId) {
      dataToSubmit.adminId = selectedSubBrokerId.value;
    } else if (selectedBrokerId) {
      dataToSubmit.adminId = selectedBrokerId;
    } else if (selectedMaster) {
      dataToSubmit.adminId = selectedMaster.value;
    } else if (selectedAdmin) {
      dataToSubmit.adminId = selectedAdmin.value;
    }

    UserEditLogServices.getTableData(dataToSubmit)
      .then((resp) => {
        setLoading(false);
        if (resp.code === 1) {
          if (resp.data.logList.length > 0) {
            setData(resp.data.logList);
          }
        } else {
          setData([]);
        }
      })
      .catch((error) => {
        console.error('Error fetching trade data:', error);
      });
  };

  return (
    <div className="container-fluid">
      <Card className="mt-2">
        <Card.Body>
          <Row>
            <Col className=" me-2" xs={5} sm={2} xl={1}>
              <b className='fss-05'>FROM DATE</b><br />
              <From fromDate={fromDate} onDateChange={setFromDate} />
            </Col>

            <Col className="me-4" xs={5} sm={2} xl={1}>
              <b className='fss-05'>TO DATE</b><br />
              <To toDate={toDate} setToDate={setToDate} />
            </Col>

            {user.adminType == 'SUPER_ADMIN' || user.adminType == 'SUPER_MASTER' ?
              <>
                <Col xs={6} sm={2}>
                  <b className="fss-05">ADMIN</b>
                  <AdminDropdown
                    adminId={user.adminId}
                    setSelectedOption={setSelectedAdmin} />
                </Col>
              </> : ""}

            {user.adminType == 'SUPER_ADMIN' || user.adminType == 'ADMIN' || user.adminType == 'SUPER_MASTER' ?
              <>
                <Col xs={6} sm={2}>
                  <b className="fss-05">MASTER</b>
                  <MasterDropdown
                    adminId={user.adminId}
                    selectedAdmin={selectedAdmin}
                    setSelectedOption={setSelectedMaster}
                    setSelectedMaster={setSelectedMaster}
                    setSelectedBrokerId={setSelectedBrokerId}
                  />
                </Col>
              </> : ""}

            {user.adminType == 'SUPER_ADMIN' || user.adminType == 'ADMIN' || user.adminType == 'MASTER' || user.adminType == 'SUPER_MASTER' ?
              <>
                <Col xs={6} sm={2}>
                  <b className="fss-05">BROKER</b>
                  <BrokerDropdown
                    selectedAdmin={selectedAdmin}
                    selectedMaster={selectedMaster}
                    setSelectedOption={setSelectedBrokerId}
                    setSelectedBrokerId={setSelectedBrokerId}
                    setSelectedSubBrokerId={setSelectedSubBrokerId}
                  />
                </Col>
              </> : ""}

           

            <Col sm={2} xs={6}>
              <b className="fss-05">CLIENT</b>
              <ClientDropdown
                selectedAdmin={selectedAdmin}
                selectedMaster={selectedMaster}
                selectedBrokerId={selectedBrokerId}
                setSelectedOption={handleSelectedClientChange}
              />

            </Col>

            <Col xs={6} sm={1} className="mt-4">
              <Button variant="success" size="sm" onClick={handleSubmit}>
                SEARCH
              </Button>
            </Col>
            {/* <Col sm={4}></Col> */}
          </Row>
        </Card.Body>
      </Card>

      <Card className="mt-2">
        <Card.Body>
          <div className="table-responsive">
            {loading ? (
              <div className="container vh-100">
                <div className="d-flex align-items-center justify-content-center h-90">
                  <div className="spinner-border text-secondary m-5" role="status" style={{ width: '4rem', height: '4rem' }}>
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              </div>
            ) : (
              <DataTable
                className="mt-1 table table-striped text-center  bg-secondary-row fss-09 table th"
                columns={columns}
                data={data}
              />
            )}
          </div>
        </Card.Body>
      </Card>
    </div>
  );
}

export default Usereditlog;
